import { useNavigate, useLocation } from 'react-router-dom';



function StripeOnboardingResult() {
    const navigate = useNavigate();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const status = query.get('status');

    const handleContinue = () => {
        navigate('/profile', {
            state: {
                tab_name: status === 'success' ? 'withdrawal' : 'withdrawal'
            }
        });
    };

    return (
        <>
            <div className="payment-status-center">
                <div className='payment-status text-center p-5' style={{ maxWidth: "500px", background: "rgba(255, 255, 255, 0.08)", backdropFilter: "blur(15px)", border: "1px solid rgba(255, 255, 255, 0.15)", borderRadius: "24px" }}>
                    {status === "success" ? (
                        <div className='payment-success'>
                            <i className="fa-solid fa-circle-check text-success mb-4 animate__animated animate__zoomIn" style={{ fontSize: "80px" }}></i>
                            <h2 className="text-white fw-bold mb-3">Onboarding Successful!</h2>
                            <p className="text-white-50 fs-6 px-3">
                                Your Stripe account has been linked successfully. You are now verified and ready to request withdrawals.
                            </p>
                        </div>
                    ) : (
                        <div className='payment-failed'>
                            <i className="fa-solid fa-circle-xmark text-danger mb-4 animate__animated animate__zoomIn" style={{ fontSize: "80px" }}></i>
                            <h2 className="text-white fw-bold mb-3">Onboarding Incomplete</h2>
                            <p className="text-white-50 fs-6 px-3">
                                It looks like the onboarding verification was not completed. Please try again to enable withdrawals.
                            </p>
                        </div>
                    )}

                    <br />

                    <button
                        onClick={handleContinue}
                        className="button btn-lg btn-theme full-rounded animated right-icn mt-3 w-100"
                        style={{ border: "none" }}
                    >
                        <span>
                            {status === "success" ? "Go to Profile" : "Try Again"}
                            <i className="glyph-icon flaticon-hearts" aria-hidden="true" />
                        </span>
                    </button>
                </div>
            </div>
        </>
    );
}

export default StripeOnboardingResult;